<!-- 设备保养记录 -->
<style>
.baoyangxianginput {
  width: 1.25rem;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/maintain/bill/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('baoyangdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('baoyangfangshi')">
            <yi_dictionary_select :type="'EQUIPMENT_MAINTAIN_MODE'" :ids.sync="yt.conditions.mode"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baoyangzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_MAINTAIN_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('querenzhuangtai')">
            <yi_dictionary_select :type="'WORKSHOP_CONFIRMATION_STATUS'" :ids.sync="yt.conditions.confirmStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuabaoyangshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planTimeStart" :end.sync="yt.conditions.planTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" type="primary" plain v-if="utils.checkPower('web_equipment_maintenance_init')" @click="yt.showEditDialog('chushihuabaoyangdan', null, '600px',beforeShowInitBillDialog)">
          {{ $t('chushihuabaoyangdan') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog)" v-if="utils.checkPower('web_equipment_maintenance_create')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button :loading="exportLoading" size="mini" @click="exportExcel()" v-if="utils.checkPower('web_equipment_maintenance_export_detail')" type="primary">
          {{ $t('daochumingxixiang') }}
        </el-button>
        <el-button :loading="batchDeleteLoading" :disabled="selectedRows.length === 0" size="mini" @click="batchDelete()" v-if="utils.checkPower('web_equipment_maintenance_batchDelete')" type="danger">
          {{ $t('piliangshanchu') }}
        </el-button>
      </template>
      <!-- 自定义字段显示 -->
      <template #tupian="scope">
        <div>
          <div v-if="!scope.row.imageList">
            <el-button type="text" :loading="scope.row.fileLoading" @click="downFiles(scope.row)">点击查看</el-button>
          </div>
          <div v-if="scope.row.imageList && scope.row.imageList.length > 0">
            <el-image style="width: 100px; height: 100px" :src="scope.row.imageList[0]" :preview-src-list="scope.row.imageList"> </el-image>
          </div>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('baoyangxiang', scope.row, '70%')" v-if="utils.checkPower('web_equipment_maintenance_item_page')">
              {{ $t('baoyangxiang') }}
            </el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button
              type="text"
              @click="
                yt.editObj = scope.row;
                yt.req('POST', '/web/equipment/maintain/bill/confirm');
              "
              v-if="utils.checkPower('web_equipment_maintenance_workshop_confirm') && scope.row.confirmStatus != 1 && scope.row.status == 3"
            >
              {{ $t('chejianqueren') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status != 3 && scope.row.mode == 2" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2')">{{ $t('bianji') }} </el-button>
            <el-button v-if="scope.row.status == 1 && utils.checkPower('web_equipment_maintenance_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/maintain/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="editDialogTitle" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 保养项 -->
      <template v-if="yt.editObj.action == 'baoyangxiang'">
        <div class="dialog-scroller">
          <maintenance_item :maintainItem="yt.editObj" ref="maintainItem"></maintenance_item>
        </div>
      </template>
      <!-- 初始化保养单 -->
      <template v-if="yt.editObj.action == 'chushihuabaoyangdan'">
        <div class="dialog-scroller">
          <el-form ref="initBillFormRef" :inline="true" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('baoyangfenzu')" label-width="210px" :required="true" size="mini">
              <el-select v-model="yt.editObj.standardGroupId" filterable clearable :loading="standardGroupLoading" :placeholder="$t('qingxuanze')" style="width: 320px;" @change="onInitStandardGroupChange">
                <el-option v-for="g in standardGroupOptions" :key="g.id" :label="g.group" :value="g.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')" label-width="210px" :required="true" size="mini">
              <el-select
                v-model="yt.editObj.sns"
                multiple
                filterable
                collapse-tags
                :loading="groupEquipmentLoading"
                :disabled="!yt.editObj.standardGroupId"
                :placeholder="yt.editObj.standardGroupId ? $t('qingxuanze') : '请先选择保养分组'"
                style="width: 320px;"
              >
                <el-option
                  v-for="item in groupEquipmentOptions"
                  :key="item.equipmentId || item.id"
                  :label="formatGroupEquipmentLabel(item)"
                  :value="item.equipmentSn"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('baoyangmingxi')" label-width="210px" :required="true" size="mini">
              <el-input
                :value="`${(yt.editObj.detailIds || []).length}项`"
                suffix-icon="el-icon-arrow-down"
                :disabled="!yt.editObj.standardGroupId"
                readonly
                @click.native="openInitDetailDialog"
              >
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('baoyangfangshi')" :required="true" label-width="210px">
              <el-input :value="$t('dingqibaoyang')" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuabaoyangshijian')" :required="true" label-width="210px">
              <yi_time_input :time.sync="yt.editObj.planTime" type="date" format="yyyy-MM-dd"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')" label-width="210px">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" type="primary" :loading="initBillSaving" @click="submitInitBill">{{ $t('baocun') }}</el-button>
        </span>
        <el-dialog :visible.sync="isShowInitDetailDialog" :title="$t('baoyangmingxi')" width="860px" append-to-body :close-on-click-modal="false">
          <el-table
            ref="initDetailTableRef"
            size="mini"
            border
            stripe
            style="width: 100%;"
            height="420"
            :data="standardDetailOptions"
            v-loading="detailOptionsLoading"
            @selection-change="onInitDetailSelectionChange"
          >
            <el-table-column v-for="(col, idx) in initDetailColumns" :key="idx" :type="col.type" :label="col.label ? $t(col.label) : ''" :prop="col.prop" :width="col.width">
            </el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancelInitDetailDialog">{{ $t('quxiao') }}</el-button>
            <el-button size="mini" type="primary" @click="confirmInitDetailDialog">{{ $t('queding') }}</el-button>
          </span>
        </el-dialog>
      </template>
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shebeimingcheng')" label-width="210px" :required="true" size="mini">
              <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
            </el-form-item>
            <!-- 保养方式,默认选中,不可修改 ，只做显示，不绑定值，后台默认值为“临时保养”-->
            <el-form-item :label="$t('baoyangfangshi')" :required="true" label-width="210px">
              <el-input :value="$t('linshibaoyang')" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('jihuabaoyangshijian')" :required="true" label-width="210px">
              <yi_time_input :time.sync="yt.editObj.planTime" :type="'datetime'"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')" label-width="210px">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <p style="font-size: 18px;">{{ $t('baoyangxiang') }}</p>
            <el-form-item :label="$t('baoyangbuwei')" :required="true" label-width="160px"> </el-form-item>
            <el-form-item :label="$t('baoyangneirong')" :required="true" label-width="210px"> </el-form-item>
            <el-form-item :label="$t('zhuyishixiang')" label-width="205px"> </el-form-item>
            <el-form-item v-for="(item, index) in yt.editObj.itemList" :key="index" label-width="30px" size="mini">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <el-input v-model="item.part" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="4">
                <el-input v-model="item.content" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="4">
                <el-input v-model="item.attention" class="baoyangxianginput" type="text" size="mini"> </el-input>
              </el-col>
            </el-form-item>
            <br />
            <el-form-item label-width="30px" size="mini">
              <el-col :span="4">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('tianjiayitiaobaoyangxiang') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/maintain/bill/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shebeimingcheng')" label-width="210px" :required="true" size="mini">
            <yi_cross_select :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentId" disabled> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('baoyangfangshi')" :required="true" label-width="210px">
            <yi_dictionary_select :type="'EQUIPMENT_MAINTAIN_MODE'" :ids.sync="yt.editObj.mode" disabled> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuabaoyangshijian')" :required="true" label-width="210px">
            <yi_time_input :time.sync="yt.editObj.planTime" :type="'datetime'"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')" label-width="210px">
            <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form label-width="150px">{{ $t('baoyangxiang') }}</el-form>
          <el-form-item :label="$t('baoyangbuwei')" :required="true" label-width="160px"> </el-form-item>
          <el-form-item :label="$t('baoyangneirong')" :required="true" label-width="210px"> </el-form-item>
          <el-form-item :label="$t('zhuyishixiang')" label-width="205px"> </el-form-item>
          <el-form-item v-for="(item, index) in yt.editObj.itemList" :key="index" label-width="30px" size="mini">
            <el-col :span="0.1">
              <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
            </el-col>
            <el-col :span="0.8">&nbsp;</el-col>
            <el-col :span="4">
              <el-input v-model="item.part" class="baoyangxianginput" type="text" size="mini"></el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="4">
              <el-input v-model="item.content" class="baoyangxianginput" type="text" size="mini"> </el-input>
            </el-col>
            <el-col :span="4">&nbsp;</el-col>
            <el-col :span="4">
              <el-input v-model="item.attention" class="baoyangxianginput" type="text" size="mini"> </el-input>
            </el-col>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/maintain/bill/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import maintenance_item from '@@/pages/web/equipment/maintenance/maintenance_item';
import XLSX from "xlsx";
import Bury from '@/common/bury.js';
export default {
  name: 'web_equipment_maintenance_list',
  components: {
    maintenance_item
  },
  data() {
    return {
      initBillSaving: false,
      standardGroupLoading: false,
      standardGroupOptions: [],
      groupEquipmentOptions: [],
      groupEquipmentLoading: false,
      groupEquipmentUseAll: false,
      isShowInitDetailDialog: false,
      initDetailBackupIds: [],
      syncingInitDetailSelection: false,
      initDetailColumns: [
        { type: 'selection', width: 50 },
        { label: 'baoyangbuwei', prop: 'part', width: 180 },
        { label: 'baoyangneirong', prop: 'content' },
        { label: 'zhuyishixiang', prop: 'attention' }
      ],
      standardDetailOptions: [],
      detailOptionsLoading: false,
      batchDeleteLoading: false,
      selectedRows: [],
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      orderBy: { orderBy: 'createTime desc' },
      exportLoading: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return true;
          },
          width: '50',
          fixed: true
        },
        {
          label: 'baoyangdanhao',
          prop: 'no'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'baoyangfangshi',
          prop: 'mode',
          type: 'dictionary',
          key: 'EQUIPMENT_MAINTAIN_MODE',
          width: 150
        },
        {
          label: 'baoyangzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('weibaoyang')
            },
            2: {
              color: '#E6A23C',
              text: this.$t('baoyangzhong')
            },
            3: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
          }
        },
        {
          label: 'querenzhuangtai',
          type: 'tag',
          prop: 'confirmStatus',
          tags: {
            0: {
              color: '#F56C6C',
              text: this.$t('daiqueren')
            },
            1: {
              color: '#E6A23C',
              text: this.$t('yiqueren')
            }
          }
        },
        {
          label: 'jihuabaoyangshijian',
          prop: 'planTime',
          type: 'time'
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'baoyangkaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 180
        },
        {
          label: 'kaishibaoyangren',
          prop: 'startedByObject.nickname',
          width: 180
        },
        {
          label: 'baoyangjieshushijian',
          prop: 'endTime',
          type: 'time',
          width: 180
        },
        {
          label: 'jieshubaoyangren',
          prop: 'completedByObject.nickname',
          width: 180
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'baoyangpingjia',
          prop: 'comment'
        },
        {
          label: 'tupian',
          prop: 'fileIdList',
          type: 'slot'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'querenren',
          prop: 'confirmByObject.nickname'
        },
        {
          label: 'querenshijian',
          prop: 'confirmTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      ids: ''
    };
  },
  computed: {
    editDialogTitle() {
      const e = this.yt && this.yt.editObj;
      if (!e || !e.action) {
        return '';
      }
      if (e.action === 'chushihuabaoyangdan') {
        return '初始化保养单';
      }
      return this.$t(e.action);
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        planTimeStart: this.begin(),
        planTimeEnd: this.end(),
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('BASE_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      });
    }, 300);

    this.yt.setColumnsHide(['querenzhuangtai', 'querenren', 'querenshijian']);
  },
  methods: {
    openChuShiHuaBaoYangDanDialog() {
      this.yt.showEditDialog('chushihuabaoyangdan', null, 'w2', this.beforeShowInitBillDialog);
    },
    beforeShowInitBillDialog(editObj) {
      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备管理-设备保养-初始化保养单' } });
      editObj.standardGroupId = null;
      editObj.equipmentIds = [];
      editObj.detailIds = [];
      editObj.planTime = new Date(new Date().toDateString()).getTime();
      editObj.remark = '';
      this.groupEquipmentOptions = [];
      this.standardDetailOptions = [];
      this.loadStandardGroups();
      return editObj;
    },
    onInitStandardGroupChange() {
      if (!this.yt.editObj || this.yt.editObj.action !== 'chushihuabaoyangdan') {
        return;
      }
      this.yt.editObj.equipmentIds = [];
      this.yt.editObj.detailIds = [];
      this.groupEquipmentOptions = [];
      this.groupEquipmentUseAll = false;
      this.standardDetailOptions = [];
      this.isShowInitDetailDialog = false;
      if (this.$refs.initDetailTableRef) {
        this.$refs.initDetailTableRef.clearSelection();
      }
      if (this.yt.editObj.standardGroupId) {
        this.loadGroupEquipmentOptions();
        this.loadStandardDetailOptions();
      }
    },
    formatGroupEquipmentLabel(row) {
      if (!row) {
        return '';
      }
      const sn = row.equipmentSn || row.sn || '';
      const name = row.equipmentName || row.name || '';
      const base = [sn, name].filter(Boolean).join(' / ');
      return base || String(row.equipmentId || row.id || '');
    },
    formatStandardDetailLabel(row) {
      if (!row) {
        return '';
      }
      const p = row.part || '';
      const c = row.content || '';
      const base = [p, c].filter(Boolean).join(' · ');
      return base || String(row.id);
    },
    loadStandardGroups() {
      this.standardGroupLoading = true;
      this.http
        .get('/web/equipment/maintain/standard/group/page', {
          params: { pageNum: 1, pageSize: 999 }
        })
        .then(res => {
          this.standardGroupOptions = (res.data && res.data.rows) || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.standardGroupLoading = false;
        });
    },
    loadGroupEquipmentOptions() {
      if (!this.yt.editObj || !this.yt.editObj.standardGroupId) {
        this.groupEquipmentOptions = [];
        this.groupEquipmentUseAll = false;
        return;
      }
      this.groupEquipmentLoading = true;
      this.http
        .get('/web/equipment/standard/group/equipment/page', {
          params: {
            pageNum: 1,
            pageSize: 999,
            groupId: this.yt.editObj.standardGroupId
          }
        })
        .then(res => {
          const rows = (res.data && res.data.rows) || [];
          if (rows.length > 0) {
            this.groupEquipmentOptions = rows;
            this.groupEquipmentUseAll = false;
            return;
          }
          // 分组未维护设备时，兜底展示全部设备
          return this.loadAllEquipmentOptions();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
          this.groupEquipmentOptions = [];
          this.groupEquipmentUseAll = false;
        })
        .finally(() => {
          this.groupEquipmentLoading = false;
        });
    },
    loadAllEquipmentOptions() {
      return this.http
        .get('/web/equipment/standing_book/page', {
          params: {
            pageNum: 1,
            pageSize: 999
          }
        })
        .then(res => {
          this.groupEquipmentOptions = (res.data && res.data.rows) || [];
          this.groupEquipmentUseAll = true;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
          this.groupEquipmentOptions = [];
          this.groupEquipmentUseAll = false;
        });
    },
    loadStandardDetailOptions() {
      if (!this.yt.editObj || !this.yt.editObj.standardGroupId) {
        this.yt.editObj.detailIds = [];
        this.standardDetailOptions = [];
        return;
      }
      this.detailOptionsLoading = true;
      this.http
        .get('/web/equipment/maintain/standard/group/detail/page', {
          params: {
            pageNum: 1,
            pageSize: 999,
            groupId: this.yt.editObj.standardGroupId
          }
        })
        .then(res => {
          const rows = (res.data && res.data.rows) || [];
          this.standardDetailOptions = rows;
          // 默认全选保养明细
          this.yt.editObj.detailIds = rows.map(i => i.id);
          this.$nextTick(() => {
            if (this.$refs.initDetailTableRef && this.isShowInitDetailDialog) {
              this.$refs.initDetailTableRef.clearSelection();
              rows.forEach(row => {
                this.$refs.initDetailTableRef.toggleRowSelection(row, true);
              });
            }
          });
        })
        .catch(err => {
          this.$message.error(this.$t(err));
          this.standardDetailOptions = [];
          this.yt.editObj.detailIds = [];
        })
        .finally(() => {
          this.detailOptionsLoading = false;
        });
    },
    openInitDetailDialog() {
      if (!this.yt.editObj.standardGroupId) {
        this.$message.warning('请先选择保养分组');
        return;
      }
      this.initDetailBackupIds = this.utils.copy(this.yt.editObj.detailIds || []);
      this.isShowInitDetailDialog = true;
      this.$nextTick(() => {
        this.syncInitDetailSelection();
      });
    },
    syncInitDetailSelection() {
      if (!this.$refs.initDetailTableRef) {
        return;
      }
      const selectedIds = new Set(this.yt.editObj.detailIds || []);
      this.syncingInitDetailSelection = true;
      this.$refs.initDetailTableRef.clearSelection();
      this.standardDetailOptions.forEach(row => {
        if (selectedIds.has(row.id)) {
          this.$refs.initDetailTableRef.toggleRowSelection(row, true);
        }
      });
      this.$nextTick(() => {
        this.syncingInitDetailSelection = false;
      });
    },
    cancelInitDetailDialog() {
      this.yt.editObj.detailIds = this.utils.copy(this.initDetailBackupIds || []);
      this.isShowInitDetailDialog = false;
    },
    confirmInitDetailDialog() {
      this.isShowInitDetailDialog = false;
    },
    onInitDetailSelectionChange(rows) {
      if (this.syncingInitDetailSelection) {
        return;
      }
      this.yt.editObj.detailIds = (rows || []).map(item => item.id);
    },
    submitInitBill() {
      const o = this.yt.editObj;
      if (!o || o.action !== 'chushihuabaoyangdan') {
        return;
      }
      if (!o.standardGroupId) {
        this.$message.warning('请选择保养分组');
        return;
      }
      if (!o.sns || o.sns.length === 0) {
        this.$message.warning('请选择设备');
        return;
      }
      if (!o.detailIds || o.detailIds.length === 0) {
        this.$message.warning('请选择保养明细');
        return;
      }
      if (!o.planTime) {
        this.$message.warning('请选择计划保养时间');
        return;
      }
      this.initBillSaving = true;
      this.http
        .post('/web/equipment/maintain/bill/init', {
          standardGroupId: o.standardGroupId,
          sns: o.sns,
          detailIds: o.detailIds,
          planTime: o.planTime,
          remark: o.remark || '',
          mode: 1
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.initBillSaving = false;
        });
    },
    // 批量删除
    batchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning(this.$t('zhishaoxuanzeyitiaoshuju'));
        return;
      }

      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备管理-设备保养-批量删除' } });
      this.batchDeleteLoading = true;
      const ids = this.selectedRows.map(row => row.id);
      this.http.post('/web/equipment/maintain/bill/batchDelete', ids).then(res => {
        this.$message.success(this.$t(res.msg));
        this.yt.get();
      })
      .catch(err => {
        this.$message.error(this.$t(err));
      })
      .finally(() => {
        this.batchDeleteLoading = false;
      });
    },
    // 选择行数据回调
    selectionChange(e) {
      console.log('选择行数据', e);
      this.selectedRows = e || [];
    },
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end
    },
    // 根据文件id下载文件
    downFiles(row) {
      const fileIdList = row.fileIdList;
      if (fileIdList && fileIdList.length > 0) {
        this.$set(row, 'fileLoading', true);
        this.http
          .get('/web/customer/files/getFileByIds', {
            params: {
              ids: fileIdList
            }
          })
          .then(res => {
            if (res.data && res.data.length > 0) {
              const imageList = res.data.map(i => i.url);
              this.$set(row, 'imageList', imageList);
            } else {
              this.$message.warning(this.$t('meiyoutupian'));
            }
          })
          .catch(err => {
            this.$message.error(this.$t(err));
          })
          .finally(() => {
            this.$set(row, 'fileLoading', false);
          });
      } else {
        this.$message.warning(this.$t('meiyoutupian'));
      }
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng') {
        editObj.itemList = [
          {
            part: '',
            content: '',
            attention: ''
          }
        ];
      }
      return editObj;
    },
    addItem() {
      this.yt.editObj.itemList.push({
        part: '',
        content: '',
        attention: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.itemList = this.yt.editObj.itemList.filter((item, index) => {
        return index !== key;
      });
    },
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/web/equipment/maintain/bill/exportDetail?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = [this.$t('baoyangdanhao'),this.$t('shebeimingcheng'),this.$t('baoyangfangshi'),this.$t('jihuabaoyangshijian'),this.$t('baoyangbuwei'),
          this.$t('baoyangneirong'),this.$t('zhuyishixiang'),this.$t('baoyangzhouqi'),this.$t('shangcibaoyangshijian'),this.$t('baoyangzhuangtai'),this.$t('caozuoren'),this.$t('beizhu')];
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          if(listData[i].itemList!=null && listData[i].itemList!=undefined && listData[i].itemList.length > 0){
            for (let j = 0; j < listData[i].itemList.length; j++) {
              let dataArr = [];
              let item = listData[i].itemList[j];
              dataArr[tableFirst.indexOf(this.$t('baoyangdanhao'))] = listData[i].no;
              dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = listData[i].equipment? listData[i].equipment.name:'';
              dataArr[tableFirst.indexOf(this.$t('baoyangfangshi'))] = this.$t(this.store.state.dictJson['EQUIPMENT_MAINTAIN_MODE'][listData[i].mode]);
              dataArr[tableFirst.indexOf(this.$t('jihuabaoyangshijian'))] = this.dayjs(listData[i].planTime).format('YYYY-MM-DD HH:mm:ss');
              dataArr[tableFirst.indexOf(this.$t('baoyangbuwei'))] = item.part? item.part:'';
              dataArr[tableFirst.indexOf(this.$t('baoyangneirong'))] = item.content? item.content:'';
              dataArr[tableFirst.indexOf(this.$t('zhuyishixiang'))] = item.attention? item.attention:'';
              dataArr[tableFirst.indexOf(this.$t('baoyangzhouqi'))] = item.cycle? item.cycle:'';
              dataArr[tableFirst.indexOf(this.$t('shangcibaoyangshijian'))] = item.lastMaintainTime?(this.dayjs(item.lastMaintainTime).format('YYYY-MM-DD HH:mm:ss')):'';
              dataArr[tableFirst.indexOf(this.$t('baoyangzhuangtai'))] = this.$t(this.store.state.dictJson['EQUIPMENT_MAINTAIN_STATUS'][item.status]);
              dataArr[tableFirst.indexOf(this.$t('caozuoren'))] = item.operatorName ? item.operatorName : '';
              dataArr[tableFirst.indexOf(this.$t('beizhu'))] = item.remark? item.remark:'';
              tableData.push(dataArr);
            }
          }else {
            let dataArr = [];
            dataArr[tableFirst.indexOf(this.$t('baoyangdanhao'))] = listData[i].no;
            dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = listData[i].equipment? listData[i].equipment.name:'';
            dataArr[tableFirst.indexOf(this.$t('baoyangfangshi'))] = this.$t(this.store.state.dictJson['EQUIPMENT_MAINTAIN_MODE'][listData[i].mode]);
            dataArr[tableFirst.indexOf(this.$t('jihuabaoyangshijian'))] = this.dayjs(listData[i].planTime).format('YYYY-MM-DD HH:mm:ss');
            tableData.push(dataArr);
          }
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `设备保养_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  }
};
</script>
